//hook
import { UserConsumer } from '../../hooks/context/UserContext';

//mui icon
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import WeekendOutlinedIcon from '@mui/icons-material/WeekendOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import StarIcon from '@mui/icons-material/Star';
import VisibilityIcon from '@mui/icons-material/Visibility';



//translate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";

interface carBookingProps {
  element: any
}

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;
const CarBookingCard = ({element}:carBookingProps) => {
  const {t} = useTranslation()
  const {theme} = UserConsumer()
  return (
    <div className="rounded-2xl border border-gray-300 overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 group">
      <div className="relative h-52 w-full group overflow-hidden rounded-t-[15px]">
        <img
          className="h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-[1.5]"
          src={`${storageURL}/${element.car.primary_images[0]?.url}`}
          alt="car_photo"
        />
        <span className={`absolute top-3 left-3 px-3 py-1 rounded-lg text-white text-sm font-semibold 
        ${
            element.current_status === 'pending' ? 'bg-yellow-500' :
            element.current_status === 'confirmed' ? 'bg-green-500' :
            element.current_status === 'ready_for_check_in' ? 'bg-blue-500' :
            element.current_status === 'checked_in' ? 'bg-indigo-500' :
            element.current_status === 'checked_out' ? 'bg-purple-500' :
            element.current_status === 'completed' ? 'bg-teal-500' :
            element.current_status === 'cancelled' ? 'bg-red-500' :
            element.current_status === 'disputed' ? 'bg-orange-600' :
            'bg-gray-400' 
        }`}>
           {t(`${
            element.current_status === "ready_for_check_in" 
            ? theme === "host" 
              ? "ready_for_check_in_host"
              :"ready_for_check_in"
            : 
            element.current_status === "checked_in" 
              ? theme === "host"
                ? "checked_in_host"
                : "checked_in"
              : element.current_status}`)}
        </span>
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <button className={`text-white ${element.car.fuel_type === "electric" ? "!bg-electricColor hover:!bg-electricColor/70" : theme === "client" ? "!bg-customerColor hover:!bg-customerColor/70": "!bg-paretnerColor hover:!bg-paretnerColor/70"} p-3 rounded-full `}>
            <VisibilityIcon  fontSize="large" />
          </button>
        </div>
      </div>
      <div className="p-4">
        <p className="font-bold text-lg truncate">{element.car.brand.name} - {element.car.model}</p>
        <div className="flex items-center mt-2 text-yellow-500">
          <StarIcon className="!text-[#FF8F3A]"/>
          <span className="ml-1 text-gray-800 text-sm">
            {element.car.avg_rate}
          </span>
        </div>
        <div className='text-[#7F7F7F] mt-3'>
            <div className="flex justify-between items-center">
                <div className='flex items-center'>
                    <LocationOnOutlinedIcon/>
                    <span className="ml-1">{element.location_in}</span>
                </div>
                <div>
                    {i18n.language === "en" ? <KeyboardTabIcon/> : <KeyboardTabIcon className='rotate-180'/>}
                </div>
                <div className='flex items-center'>
                    <EmojiFlagsIcon/>
                    <span className="ml-1">{element.location_out}</span>
                </div>
            </div>
            <div className="mt-3">
                <div className="flex items-center">
                    <WeekendOutlinedIcon fontSize="small" />
                    <span className="ml-1">{element.car.seating_capacity} {t('seats')}</span>
                </div>
                <div className="flex items-center mt-3">
                    <MonetizationOnOutlinedIcon fontSize="small" />
                    <span className="ml-1">{element.cost} - {t("total_cost")}</span>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default CarBookingCard